/** @format */

import APIRequest from "../utils/APIRequest";

export default class BroadcastDao {
  static getListBroadcast = async (waba_id, phone_number = "") => {
    let params = "";
    if (waba_id) params += `/${waba_id}`;
    if (phone_number) {
      params += `/${phone_number}`;
    } else {
      params += `/:phonenumber`;
    }
    return await APIRequest.set(
      `v1/broadcast/listbywabaidandphone${params}`,
      "GET"
    );
  };

  static getDetailHeader = async (broadcast_id) => {
    return await APIRequest.set(
      `v1/broadcast/detailbyid/${broadcast_id}`,
      "GET"
    );
  };

  static getBroadcast = async (id) => {
    return await APIRequest.setFileDownload(
      `v1/broadcast/download-excel/${id}`,
      "GET"
    );
  };

  static getBroadcastDashboard = async (
    waba_id,
    created_at_start,
    created_at_end,
    phone_number
  ) => {
    return await APIRequest.set(
      `v1/broadcast/dashboard/${waba_id}?created_at_start=${created_at_start}&created_at_end=${created_at_end}&phone_number=${
        phone_number ?? ""
      }`,
      "GET"
    );
  };
}
